import React from 'react';
import { Box, Typography, Pressable } from '@/shared/design-system/primitives';
import { useConfigStore } from '@stores/v4/useConfigStore';

/**
 * MetabolicEngineToggle: Live debug switch for Clinical vs Heuristic math.
 */
export const MetabolicEngineToggle: React.FC = () => {
    const { engineMode, setEngineMode } = useConfigStore();

    return (
        <Box style={{ padding: '10px 20px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <Pressable 
                onPress={() => setEngineMode(engineMode === 'HEURISTIC' ? 'PHARMACOKINETIC' : 'HEURISTIC')}
                style={{ 
                    borderWidth: 1, borderColor: engineMode === 'PHARMACOKINETIC' ? '#f29b11' : '#333', 
                    padding: '6px 12px', borderRadius: 6, backgroundColor: engineMode === 'PHARMACOKINETIC' ? 'rgba(242, 155, 17, 0.1)' : 'transparent' 
                }}
            >
                <Typography style={{ fontSize: 9, fontWeight: '900', color: engineMode === 'PHARMACOKINETIC' ? '#f29b11' : '#666', letterSpacing: 1 }}>
                    {engineMode === 'HEURISTIC' ? 'STD MODEL' : 'PK ENGINE (ACTIVE)'}
                </Typography>
            </Pressable>
        </Box>
    );
};
